let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5U9nm")).then(() => parcelRequire('6xvRC'));